import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { L1Image } from '../l1/L1Image'
import { ConceptStatus } from '@fusion-advantage/backcompat'
import { isConceptStatus } from '@fusion-advantage/formlib'
import { useFormAppRelay } from '../../../lib/relay/FormAppRelay'

export enum L3ImageFormat {
	DownloadFile = 'DownloadFile',
	SvgString = 'SvgString',
}

interface L3ImageProps {
	format: L3ImageFormat
	conceptStatus: ConceptStatus|null
	thumbnail?: boolean
	width?: string|number
	height?: string|number
	onClick?: React.MouseEventHandler<HTMLImageElement>|undefined
}

interface L3ImageState {
	loading: boolean
	error: boolean
	src?: string
}

export const L3Image = ({ format, conceptStatus, thumbnail, width, height, onClick }: L3ImageProps) => {
	const { downloadFile } = useFormAppRelay()
	const [state, setState] = useState<L3ImageState>({
		loading: false,
		error: false,
	})
	useEffect(() => {
		if(!isConceptStatus(conceptStatus)) {
			setState({
				loading: false,
				error: false,
			})
			return
		}
		switch(format) {
			case L3ImageFormat.DownloadFile:
				const getSrc = async () => {
					const response = await downloadFile({BlobName: String(conceptStatus.value)})
					if(response) {
						setState({
							loading: false,
							error: false,
							src: response.SasUrl,
						})
					}
				}
				setState({
					loading: true,
					error: false,
				})
				getSrc()
				break
			case L3ImageFormat.SvgString:
				// this 20 ms delayed state change avoids a safari rendering
				// bug where the signature svg does not initially respect the
				// maxWidth and maxHeight imposed by the css in L1Image
				setState({
					loading: true,
					error: false,
				})
				setTimeout(() => setState({
					loading: false,
					error: false,
					src: `data:image/svg+xml;base64,${btoa(String(conceptStatus.value))}`
				}), 20)
				break
		}
	}, [conceptStatus, format])

	return (
		<L1Image
			{...state}
			thumbnail={thumbnail}
			width={width}
			height={height}
			onClick={onClick}
		/>
	)
}
